import { jsx as s } from "react/jsx-runtime";
import { ICON_SVG_MAP as g } from "./index.es17.js";
const p = ({ icon: e, pxSize: t, color: i, classNames: n, dataTestId: l }) => {
  var o;
  const r = (o = g) == null ? void 0 : o[e];
  return r ? /* @__PURE__ */ s(
    "svg",
    {
      "data-testid": l,
      xmlns: "http://www.w3.org/2000/svg",
      className: `${n || ""}`,
      height: `${t}px`,
      width: `${t}px`,
      fill: `${i || "#000000"}`,
      viewBox: "0 -960 960 960",
      children: /* @__PURE__ */ s("path", { d: `${r}` })
    }
  ) : null;
};
export {
  p as ForgeIcon
};
//# sourceMappingURL=index.es3.js.map
